import { applyMiddleware, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from '../reducers';
import api from '../middleware/api';

// redux-thunk v3 exports a named `thunk`, not a default. Importing it as a
// default gives undefined, and applyMiddleware then fails with a message about
// middleware not being a function that says nothing about the import.
const storeEnhancers =
  (import.meta.env.MODE !== 'production' &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const store = createStore(rootReducer, storeEnhancers(applyMiddleware(thunk, api)));

export default store;
